<div class="loyalty-for-promotion">
    <div class="loyalty-for-promotion__inner">

        <shared-list-for-promotion-items [layout]="layout" [promotionItems]="promotionItems$ | async"
            [loading]="loading$ | async">
        </shared-list-for-promotion-items>

    </div>
</div>